import axios from 'axios';

/**
 * Check if employer can view a jobseeker profile based on subscription limits
 * @param {Object} params Parameters
 * @param {number} params.employerId Employer ID
 * @param {number} params.jobseekerId Jobseeker ID
 * @param {Object} params.features Subscription features
 * @param {string} params.token Authentication token
 * @returns {Promise<Object>} Result indicating if profile can be viewed
 */
export const checkProfileViewPermission = async ({ employerId, jobseekerId, features, token }) => {
    try {
        if (!employerId || !jobseekerId || !features || !token) {
            console.error('Missing required parameters for profile view check');
            return { canView: true }; // Default to allowing view on error
        }
        
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}employers/checkProfileViewPermission`,
            { employerId, jobseekerId, features },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error checking profile view permission:', error);
        return { 
            canView: true, // Default to allowing view on error
            error: error.response?.data?.error || 'Failed to check profile view permission'
        };
    }
};

/**
 * Record a profile view
 * @param {Object} params Parameters
 * @param {number} params.employerId Employer ID
 * @param {number} params.jobseekerId Jobseeker ID
 * @param {string} params.token Authentication token
 * @returns {Promise<Object>} Success status
 */
export const recordProfileView = async ({ employerId, jobseekerId, token }) => {
    try {
        if (!employerId || !jobseekerId || !token) {
            console.error('Missing required parameters for recording profile view');
            return { success: false };
        }
        
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}employers/recordProfileView`,
            { employerId, jobseekerId },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        console.log(response.data,'response');
        return response.data;
    } catch (error) {
        console.error('Error recording profile view:', error);
        return { 
            success: false, 
            error: error.response?.data?.error || 'Failed to record profile view'
        };
    }
};

/**
 * Get profile views statistics for an employer
 * @param {Object} params Parameters
 * @param {number} params.employerId Employer ID
 * @param {string} params.token Authentication token
 * @returns {Promise<Object>} Profile views statistics
 */
export const getProfileViewStats = async ({ employerId, token }) => {
    try {
        if (!employerId || !token) {
            console.error('Missing required parameters for profile view stats');
            return { error: 'Missing required parameters' };
        }
        
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}employers/profileViewStats/${employerId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error getting profile view stats:', error);
        return { 
            error: error.response?.data?.error || 'Failed to get profile view statistics'
        };
    }
}; 